import React from "react";
import { Modal } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import Styles from "./ManualProductEntryModal.module.css";

const validationSchema = Yup.object({
  product_name: Yup.string().trim().required("Product Name is required"),
  brand_name: Yup.string().trim().required("Brand is required"),
  qty: Yup.number()
    .typeError("Quantity must be a number")
    .positive("Quantity must be greater than 0")
    .integer("Quantity must be an integer")
    .required("Quantity is required"),
  unit: Yup.string().trim().required("Unit is required"),
});

export default function ManualProductEntryModal({ show, onHide, onSubmit }) {
  const formik = useFormik({
    initialValues: {
      product_name: "",
      brand_name: "",
      qty: 1,
      unit: "",
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      onSubmit?.({
        product_name: values.product_name.trim(),
        brand_name: values.brand_name.trim(),
        qty: Number(values.qty),
        unit: values.unit.trim(),
      });
      resetForm();
    },
  });

  const handleClose = () => {
    formik.resetForm();
    onHide?.();
  };

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static">
      <Modal.Header closeButton className={Styles.modalHeader}>
        <Modal.Title className={Styles.modalTitle}>
          Product Not Listed? Add Manually
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={Styles.modalBody}>
        <form onSubmit={formik.handleSubmit}>
          {/* Product Name */}
          <div className="mb-3">
            <label className={Styles.label}>
              Product Name <span className={Styles.required}>*</span>
            </label>
            <input
              name="product_name"
              type="text"
              className={`form-control kstoreFont2 ${Styles.inputField} ${formik.touched.product_name && formik.errors.product_name
                ? "is-invalid"
                : ""
                }`}
              placeholder="Enter Product Name"
              value={formik.values.product_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.product_name && formik.errors.product_name && (
              <p className={Styles.errorText}>{formik.errors.product_name}</p>
            )}
          </div>

          {/* Brand */}
          <div className="mb-3">
            <label className={Styles.label}>
              Brand <span className={Styles.required}>*</span>
            </label>
            <input
              name="brand_name"
              type="text"
              className={`form-control kstoreFont2 ${Styles.inputField} ${formik.touched.brand_name && formik.errors.brand_name
                ? "is-invalid"
                : ""
                }`}
              placeholder="Enter Brand Name"
              value={formik.values.brand_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.brand_name && formik.errors.brand_name && (
              <p className={Styles.errorText}>{formik.errors.brand_name}</p>
            )}
          </div>

          {/* Unit */}
          <div className="mb-3">
            <label className={Styles.label}>
              Unit <span className={Styles.required}>*</span>
            </label>
            <input
              name="unit"
              type="text"
              className={`form-control kstoreFont2 ${Styles.inputField} ${
                formik.touched.unit && formik.errors.unit ? "is-invalid" : ""
              }`}
              placeholder="Specify unit (e.g. 500g, 1kg, 1L)"
              value={formik.values.unit}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.unit && formik.errors.unit && (
              <p className={Styles.errorText}>{formik.errors.unit}</p>
            )}
          </div>

          {/* Qty */}
          <div className="mb-3">
            <label className={Styles.label}>
              Qty <span className={Styles.required}>*</span>
            </label>
            <input
              name="qty"
              type="number"
              min="1"
              className={`form-control kstoreFont2 ${Styles.inputField} ${
                formik.touched.qty && formik.errors.qty ? "is-invalid" : ""
              }`}
              placeholder="Qty"
              value={formik.values.qty}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.qty && formik.errors.qty && (
              <p className={Styles.errorText}>{formik.errors.qty}</p>
            )}
          </div>

          {/* Action Buttons */}
          <div className={Styles.btnContainer}>
            <button
              type="button"
              className={Styles.cancelBtn}
              onClick={handleClose}
            >
              Cancel
            </button>
            <button type="submit" className={Styles.submitBtn}>
              Add to Cart
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}
